import './EditConversationTemplate.scss';

import { ChangeEvent, FC, useEffect, useState } from 'react';
import { wrapHBSTemplatesAndReplaceNewLinesWithBRTags } from 'functions/wrapHandleBarsTemplates';
import { PromptTemplate } from 'models/Prompt';
import { PromptFlow } from 'models/PromptFlow';
import { Alert, Button } from 'react-bootstrap';

interface EditConversationTemplateProps {
  promptFlow: PromptFlow
  onConversationTemplateChanged: (prompts: PromptTemplate[]) => void;
}

const EditConversationTemplate: FC<EditConversationTemplateProps> = ({ promptFlow, onConversationTemplateChanged }) => {

  const [prompts, setPrompts] = useState(promptFlow.conversationTemplate);
  const defaultPrompt: PromptTemplate = {
    orderId: 0,
    inputTemplate: '',
  };

  const onChangePromptText = (e: ChangeEvent<HTMLElement>, index: number) => {
    const updatedPrompts = [...prompts];
    const unformattedHtml = e.target.innerHTML
      .replaceAll('<code class="hbs-template">', '')
      .replaceAll('</code>', '')
      .replaceAll('<br>', '\r\n')
      .replaceAll('<br/>', '\r\n');

    const tmp = document.createElement("div");
    tmp.innerHTML = unformattedHtml;
    const { innerText } = tmp;

    (updatedPrompts[index] as PromptTemplate).inputTemplate = innerText;
    setPrompts(updatedPrompts);
    onConversationTemplateChanged(updatedPrompts);
  };

  const addPrompt = () => {
    const updatedPrompts = [...prompts];
    const promptToAdd = { ...defaultPrompt };
    if (updatedPrompts.length === 0) {
      promptToAdd.orderId = 1;
    } else {
      promptToAdd.orderId = updatedPrompts[updatedPrompts.length - 1].orderId + 1;
    }
    updatedPrompts.push(promptToAdd);
    setPrompts(updatedPrompts);
  };

  useEffect(() => {
    setPrompts(promptFlow.conversationTemplate);
  }, [promptFlow.conversationTemplate])

  return (
    <div className="EditConversationTemplate">
      <Alert variant="info">
        For information about template fields available in prompts, see the {" "}
        <a href="https://blabberjax.atlassian.net/wiki/x/DACRGg" target="_blank" rel="noreferrer">
          Template Field Reference Guide
        </a>
      </Alert>
      <ol className="prompt">
        {prompts.map((prompt, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index} className='my-3'>
            <div
              contentEditable
              className="prompt-template form-control"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: wrapHBSTemplatesAndReplaceNewLinesWithBRTags(prompt.inputTemplate) }}
              onBlur={(e) => { onChangePromptText(e, index) }}
            />
          </li>
        ))}
      </ol>
      <div className="offset">
        <Button variant="secondary" onClick={addPrompt}>
          <i className='bi bi-plus' />
          Add Prompt
        </Button>
      </div>
    </div>
  );
}

export default EditConversationTemplate;
